import React, { createContext, useContext, useEffect, useState } from 'react'

const WebsiteContext = createContext()
let setFlashMessageInternal

export const useWebsite = () => {
  return useContext(WebsiteContext)
}

export const useIsWideScreen = () => {
  const [isWideScreen, setIsWideScreen] = useState(window.innerWidth > 768)

  useEffect(() => {
    const handleResize = () => {
      setIsWideScreen(window.innerWidth > 768)
    }

    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return isWideScreen
}

export const WebsiteProvider = ({ children }) => {
  const [website, setWebsite] = useState('')
  const [flashMessage, setFlashMessageInternalState] = useState(null)

  useEffect(() => {
    const getWebsite = () => {
      const hostname = window.location.hostname

      if (process.env.NODE_ENV === 'production') {
        let domain = hostname.replace(/^(https?:\/\/)?(www\.)?/, '')
        domain = domain.split('.')[0]
        return domain
      } else {
        return 'revesdebarousse-dev'
      }
    }

    setWebsite(getWebsite())
  }, [])

  useEffect(() => {
    let timer
    if (flashMessage) {
      timer = setTimeout(() => {
        setFlashMessageInternalState(null)
      }, 5000)
    }
    return () => clearTimeout(timer)
  }, [flashMessage])

  setFlashMessageInternal = (message, type) => {
    setFlashMessageInternalState({ message, type })
  }

  return (
    <WebsiteContext.Provider
      value={{
        setFlashMessage: setFlashMessageInternal,
        website,
      }}
    >
      {children}

      {flashMessage && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            backgroundColor:
              flashMessage.type === 'error'
                ? 'rgb(120, 0, 0)'
                : flashMessage.type === 'success'
                ? 'rgb(0, 120, 0)'
                : 'rgb(120, 120, 0)',
            color: '#ffffff',
            textAlign: 'center',
            padding: '10px',
            zIndex: 9999999,
          }}
        >
          {flashMessage.message}
        </div>
      )}
    </WebsiteContext.Provider>
  )
}

export const setFlashMessage = (message, type) => {
  setFlashMessageInternal(message, type)
}

export default WebsiteContext
